var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusinessTransferLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 7.34118,
    fill: "#646174"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.436 6.72967C16.4505 6.72967 13.5872 7.93849 11.4761 10.0902C9.36496 12.2419 8.17895 15.1602 8.17895 18.2032C8.17895 21.2462 9.36496 24.1645 11.4761 26.3162C13.5872 28.4679 16.4505 29.6768 19.436 29.6768L19.436 18.2032L19.436 6.72967Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5696 45.1932C35.5552 45.1932 38.4184 43.9844 40.5295 41.8327C42.6407 39.681 43.8267 36.7626 43.8267 33.7196C43.8267 30.6767 42.6407 27.7583 40.5295 25.6066C38.4184 23.4549 35.5552 22.2461 32.5696 22.2461L32.5696 33.7196L32.5696 45.1932Z",
    fill: "#FCFCFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2706 19.4309C45.2706 16.4453 44.0618 13.5821 41.9101 11.4709C39.7583 9.35984 36.84 8.17383 33.797 8.17383C30.7541 8.17383 27.8357 9.35984 25.684 11.4709C23.5323 13.5821 22.3235 16.4453 22.3235 19.4309L33.797 19.4309L45.2706 19.4309Z",
    fill: "#FCFCFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80657 32.5642C6.80657 35.5498 8.01539 38.4131 10.1671 40.5242C12.3188 42.6353 15.2371 43.8213 18.2801 43.8213C21.3231 43.8213 24.2414 42.6353 26.3931 40.5242C28.5448 38.4131 29.7537 35.5498 29.7537 32.5642L18.2801 32.5642L6.80657 32.5642Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessTransferLogo);
export default __webpack_public_path__ + "static/media/BusinessTransferLogo.fd3c23e83d64753eb3f314836f8e8d07.svg";
export { ForwardRef as ReactComponent };